import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import States from 'login-constants/states';
import ContextLink from '../ContextLink';
import TransparentButton from '../Buttons/TransparentButton';

const styles = StyleSheet.create({
  contextLink: {
    textDecoration: 'none',
  },
});

interface SignInButtonProps {
  buttonText: 'Sign up' | 'Sign in';
}

export default class SignInButton extends React.PureComponent<SignInButtonProps> {
  render() {
    const { buttonText } = this.props;
    return (
      <ContextLink
        className={css(styles.contextLink)}
        to={buttonText === 'Sign in' ? States.LOGIN : States.SIGNUP}
        id={buttonText === 'Sign in' ? 'it-SignInLink' : 'it-SignUpLink'}
      >
        <TransparentButton text={buttonText} />
      </ContextLink>
    );
  }
}
